import deleteFavoritesList from './delete-favorites-list';

export { deleteFavoritesList };

export default deleteFavoritesList;
